import {
  MinusCircleOutlined,
  PlusOutlined,
  UserAddOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  message,
  Tooltip,
} from 'antd';
import { Option } from 'antd/es/mentions';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import ReactQuill from 'react-quill';
import { Link, useNavigate } from 'react-router-dom';
import initialTermsCondition from '../../Common/intialTermsCondition';
import { ReactComponent as Back } from '../../Images/Back.svg';
import {
  createCustomer,
  fetchCustomerDropdown,
  resetCurrentCustomerPage,
  resetCustomerList,
} from '../../slices/customer';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDieProfileById,
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileList,
  resetDieProfileData,
} from './../../slices/die-profile';
import { createDieQuotation } from '../../slices/die-quotation';

import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { debounce } from 'lodash';

function AddDieQuotation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [minimumOrderQty, setMinimumOrderQty] = useState('<300');
  const [qty, setQty] = useState('1');
  const [dieRight, setDieRight] = useState('Own');
  const { data: settingData } = useSelector(state => state.setting);
  const [editorValue, setEditorValue] = useState('');
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [searchAlloy, setSearchAlloy] = useState('');

  const handleDieRightChange = e => {
    setDieRight(e.target.value);
  };
  const handleQtyChange = e => {
    const value = e.target.value;
    setQty(value);
  };
  const {
    list: customerList,
  } = useSelector(state => state.customer);
  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);

  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const [isCustomerModalVisible, setIsCustomerModalVisible] = useState(false);
  const [customerForm] = Form.useForm();

  useEffect(() => {
    dispatch(
      fetchCustomerDropdown({
        page: 1,
        pagesize: 1000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );

    dispatch(
      fetchAlloyDropdown({
        page: 1,
        pagesize: 1000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );

    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );
  
    dispatch(resetDieProfileList());
    dispatch(resetCurrentCustomerPage());
    dispatch(resetCurrentAlloyListPage());
    dispatch(resetDieProfileData());
    dispatch(resetCustomerList());
    dispatch(resetAlloyList());
  }, [dispatch, page, pagesize, search, orderBy]);

  useEffect(() => {
    form.setFieldsValue({
      die_right: dieRight,
      minimum_order_qty: minimumOrderQty,
    });
    const terms = settingData?.term_and_condition_settings?.quotation_terms_and_conditions;

    if (terms) {
      setEditorValue(terms);
      form.setFieldsValue({
        terms_and_condition: terms,
      });
    }
  }, [settingData, dieRight, form]);

  const onScrollAlloy = async event => {
    const target = event.target;
    if (!alloyLoading && alloyHasMore && target.scrollTop + target.offsetHeight === target.scrollHeight) {
      dispatch(fetchAlloyDropdown({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };
  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      setSearchCustomer(value);
      dispatch(resetCustomerList());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(resetCustomerList());
      dispatch(resetCurrentCustomerPage());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
    }
  };
  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      setSearchAlloy(value);
      dispatch(resetAlloyList());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const handleDieProfileChange = async (value, index) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('die_quotation_details'),
    ];
    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      profile_no: value?.value, // Set the selected profile ID
    };
    try {
      const response = await dispatch(
        fetchDieProfileById(value?.value),
      ).unwrap();
      if (response?.results?.data?.length > 0) {
        const customerRefNo =
          response.results.data[0]?.customer_reference_number || '';
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_no: customerRefNo,
        };
        form.setFieldsValue({
          quotation_details: updatedQuotationDetails,
          customer_reference_no: customerRefNo,
        });
      }
    } catch (error) {
      console.error('Error fetching customer reference number:', error);
    }
    form.setFieldsValue({
      die_quotation_details: updatedQuotationDetails,
    });
  };

  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData()); // Reset the list when searching
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 100,
        search: value || '',
      }),
    );
  }, 300);

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 100 }));
    }
  };

  const onScrollDieProfile = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;
      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 100,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const showCustomerModal = () => {
    setIsCustomerModalVisible(true);
  };
  const handleCustomerModalCancel = () => {
    setIsCustomerModalVisible(false);
    customerForm.resetFields();
  };
  const handleChange = value => {
    setEditorValue(value);
  };

  useEffect(() => {
    dispatch(fetchAlloyDropdown());
    dispatch(resetCurrentDieProfilePage());
    dispatch(resetDieProfileList());
    dispatch(resetDieProfileData());
    dispatch(resetAlloyList());
    dispatch(resetCurrentAlloyListPage());
  }, []);

  const handleSaveCustomer = values => {
    dispatch(createCustomer({ values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Customer Created Successfully!');
          handleCustomerModalCancel();
          dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
        }
      })
      .catch(error => {
        console.error('Error saving customer:', error);
      });
  };
  

  const handleFinish = values => {
    setBtnLoading(true);

    dispatch(createDieQuotation({ values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          message.success('Die Quatation Created Successfully!');
          dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
          navigate('/die-quotation-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  const handleChangeCustomer = value => {
    setSearchCustomer(value);
  };

  return (
    <>
      <div style={{
        position: "sticky",
        zIndex: "1000",
        background: "#fff",
        padding: "16px",
        top: 0
      }}>
        <div className="pagenamerow">
          <h2>Create Die Quotation</h2>
          <div className="bredcrumbwrp">
            <Link to="/die-quotation-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/die-quotation-list">Die Quotations</Link> },
                { title: 'Create Die Quotation' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          form={form}
          onFinish={handleFinish}
          layout="vertical"
          initialValues={{
            die_right: dieRight,
            customer: null,
            minimum_order_qty: '',
            sample_delivery: null,
            terms_and_condition: '',
            die_quotation_details: [
              {
                profile_no: null,
                customer_reference_no: '',
                alloy: null,
                press_capacity: '',
                unit_of_measurement: '',
                quantity: 1,
                profile_devlopment_cost: '',
              }, // Example initial contact person
            ],
          }}
        >
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                name="customer"
                label="Customer Name"
                rules={[
                  { required: true, message: 'Please select company name' },
                ]}
                placeholder="Please Select Company Name"
              >
                <Space.Compact style={{ width: '100%' }}>
                  <AutoOpenSelect
                    placeholder="Please Select Company Name"
                    value={searchCustomer}
                    style={{ width: 'calc(100% - 40px)' }}
                    onChange={value => {
                      form.setFieldValue('customer', value); // Update field value
                      form.validateFields(['customer']); // Trigger validation
                      handleChangeCustomer(value);
                    }}
                    allowClear
                    showSearch={true}
                    onSearch={handleSearchCustomer}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {[
                      ...new Map(
                        customerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                        {el.customer_name}
                      </Option>
                    ))}
                  </AutoOpenSelect>
                  <Button
                    type="primary"
                    icon={<UserAddOutlined />}
                    onClick={showCustomerModal}
                  />
                </Space.Compact>
              </Form.Item>
            </Col>
            <Modal
              title="Add New Customer"
              open={isCustomerModalVisible}
              onCancel={handleCustomerModalCancel}
              footer={[
                <Button key="back" onClick={handleCustomerModalCancel}>
                  Cancel
                </Button>,
                <Button
                  type="primary"
                  onClick={() => customerForm.submit()}
                  htmlType="submit"
                  key="save"
                >
                  Save Customer
                </Button>,
              ]}
            >
              <Form
                form={customerForm}
                layout="vertical"
                onFinish={handleSaveCustomer}
              >
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="customer_name"
                      label="Company Name"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter company name',
                        },
                        {
                          pattern: /^[a-zA-Z0-9\s]+$/,
                          message:
                            'Company Should be Alphbate ,number and space',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Company Name"
                        onChange={e => {
                          const value = e.target.value;
                          const formattedValue = value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());
                          customerForm.setFieldsValue({
                            customer_name: formattedValue,
                          }); // Update Form state
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="person_name"
                      label="Person Name"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter valid name',
                        },
                        {
                          pattern: /^[a-zA-Z\s]+$/,
                          message: 'Please enter valid name',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Name"
                        onChange={e => {
                          const value = e.target.value;
                          const formattedValue = value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());
                          customerForm.setFieldsValue({
                            person_name: formattedValue,
                          }); // Update Form state
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[
                        {
                          type: 'email',
                          required: true,
                          message: 'Please enter a valid email',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Email Address" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label="Mobile Number"
                      name={`phone_number`}
                      rules={[
                        {
                          required: true,
                          message: 'Please input your phone number!',
                        },
                      ]}
                    >
                      <PhoneInput
                        country={'in'} // Default country (India)
                        enableSearch={true} // Enable searching for countries
                        placeholder="Enter phone number"
                        onChange={value => value} // Handle change
                        containerStyle={{ flex: 1 }} // Ensure proper layout inside the container
                        inputStyle={{
                          width: '100%',
                          height: '40px',
                          border: '1px solid #d9d9d9',
                          borderRadius: '4px',
                        }} // Input field styling
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Modal>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="Minimum Order Qty (Kg)"
                name="minimum_order_qty"
                rules={[{ required: true, message: 'Please select an option' }]}
              >
                <Radio.Group
                  name="minimum_order_qty"
                  value={minimumOrderQty}
                  onChange={e => setMinimumOrderQty(e.target.value)}
                >
                  <Radio value="<300">&lt;300</Radio>
                  <Radio value="300 - 500">300 - 500</Radio>
                  <Radio value=">500">&gt;500</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="Die Right" name="die_right">
                <div className="flex items-center">
                  <Radio.Group
                    className="flex"
                     onChange={handleDieRightChange}
                    value={dieRight}
                  >
                    <Radio value="Own">{settingData?.company_settings?.company_name}</Radio>
                    <Radio value="Customer">Customer</Radio>
                  </Radio.Group>
                </div>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} xl={6}>
              <div style={{ marginBottom: '3px' }}>
                <label className="customlabel">Sample Delivery</label>{' '}
                <Tooltip
                  placement="topLeft"
                  title=" Within __ weeks from the date of drawing approval and die cost."
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </div>
              <Form.Item name="sample_delivery" label="">
                <Input
                  placeholder="Enter Sample Delivery"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ sample_delivery: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="die_quotation_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      wrap={false}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'profile_no']}
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a section number',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Section Number"
                                style={{ width: '100%' }}
                                labelInValue
                                value={
                                  form.getFieldValue([
                                    'die_quotation_details',
                                    name,
                                    'profile_no',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'die_quotation_details',
                                        name,
                                        'profile_no',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  handleDieProfileChange(value, name)
                                }
                                onSearch={handleSearchDieProfile}
                                allowClear
                                onClear={() => {
                                  dispatch(resetDieProfileData());
                                  dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 100 }));
                                }}
                                showSearch={true}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {dieProfileList.map(el => (
                                  <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                                    {el.die_number}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              name={[name, 'customer_reference_no']}
                              label="Customer Reference No."

                            >
                              <Input placeholder="Enter Customer Ref.No" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={
                                  form.getFieldValue([
                                    'die_quotation_details',
                                    name,
                                    'alloy',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'die_quotation_details',
                                        name,
                                        'alloy',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['die_quotation_details', name, 'alloy'],
                                    value,
                                  )
                                } // Directly set number
                                onSearch={handleSearchAlloy}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;

                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();

                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyList.map(el => (
                                  <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                                    {el?.alloy_code} - {el?.standard_name}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'press_capacity']}
                              label="Press Capacity (Tonnage)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid press capacity',
                                },
                              ]}
                            >
                              <Input placeholder="Enter Press Capacity" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} lg={6} xxl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'unit_of_measurement']}
                              label="Unit Of Measurement"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter unit of measurement',
                                },
                              ]}
                            >
                              <Input placeholder="Unit Of Measurement" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'quantity']}
                              label="Quantity"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid quantity',
                                },
                                {
                                  validator: (_, value) => {
                                    if (value && isNaN(value)) {
                                      return Promise.reject(
                                        'Only numbers are allowed',
                                      );
                                    }
                                    if (
                                      value &&
                                      parseFloat(value) > 9999999999
                                    ) {
                                      return Promise.reject('Value too large');
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter Quantity"
                                value={qty}
                                onChange={handleQtyChange}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'profile_devlopment_cost']}
                              label="Profile Development Cost"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid cost',
                                },
                                {
                                  validator: (_, value) => {
                                    if (value && isNaN(value)) {
                                      return Promise.reject(
                                        'Only numbers are allowed',
                                      );
                                    }
                                    if (
                                      value &&
                                      parseFloat(value) > 9999999999
                                    ) {
                                      return Promise.reject('Value too large');
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input placeholder="Enter Profile Devlopment Cost" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              danger
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '0',
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))}

                  <div className="w-100 flex justify-end ">
                    <Button
                      type="primary"
                      onClick={() => {
                        if (fields.length < 15) {
                          add();
                        } else {
                          message.error('You can only add up to 15 records.');
                        }
                      }}
                      icon={<PlusOutlined />}
                    >
                      Add Item
                    </Button>
                  </div>
                </>
              )}
            </Form.List>
          </div>

          <Col xs={24}>
            <Form.Item
              name="terms_and_condition"
              label="Terms & Condition"
              rules={[{ required: true, message: 'Terms & Condition' }]}
              valuePropName="content"
            >
              <ReactQuill
                value={editorValue}
                onChange={handleChange}
                theme="snow"
                modules={{
                  toolbar: [
                    [{ header: '1' }, { header: '2' }, { font: [] }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['bold', 'italic', 'underline'],
                    [{ align: [] }],
                    ['link', 'image'],
                    ['blockquote', 'code-block'],
                  ],
                }}
              />
            </Form.Item>
          </Col>
          <div className="flex justify-end">
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
              Create Die Quotation
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default AddDieQuotation;
